import React, { useState } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div>
      <header>
        <nav>
          <i className="bi bi-x-diamond-fill logo"></i>
          <ul id="menu" className={menuOpen ? 'open' : ''}>
            <li><a href="">Home</a></li>
            <li><a href="">About</a></li>
            <li><a href="">Service</a></li>
            <li><a href="">Project</a></li>
            <i class="fas fa-times-circle" id="close" onClick={toggleMenu}></i>
            {/* <i className="bi bi-x-circle" id="close" onClick={toggleMenu}></i> */}
          </ul>
          <i class="fas fa-bars" id="open" onClick={toggleMenu}></i>
          {/* <i className="bi bi-menu-button" id="open" onClick={toggleMenu}></i> */}
        </nav>
      </header>
    </div>
  );
}

export default Navbar;
